import { Stack, Typography, Link } from "@mui/material";
import React from "react";

type Props = {};

const LegalDisclaimer = (props: Props) => {
  return (
    <Stack 
      direction="column" 
      alignItems="flex-start" 
      p={2} 
      spacing={3}
      sx={{ maxWidth: 1100, margin: "0 auto", lineHeight: 1.7 }}
    >
      <Typography variant="h5" fontWeight="bold" textAlign="left">
        Official Website
      </Typography>

      <Typography variant="h6" textAlign="justify" fontWeight="bold">
        The official website of Modern College of Physiotherapy is{" "}
        <Link href="http://www.mcopt.ac.in/" target="_blank" underline="hover"
        sx={{
          "&:hover": {
            color: "secondary.main",
          },
        }}>
          www.mcopt.ac.in
        </Link>
        .
      </Typography>

      <Typography variant="body1" textAlign="justify">
        All the contents of this website are only for general information or
        use. Modern College of Physiotherapy excludes any warranty, express or
        implied, as to the quality, accuracy, and completeness of the website.
      </Typography>

      <Typography variant="body1" textAlign="justify">
        Modern College of Physiotherapy will not be liable for any damages
        arising from the use of this website. The copyright of the proprietary
        material contained in this website remains solely with Modern College of
        Physiotherapy.
      </Typography>

      <Typography variant="body1" textAlign="justify">
        Modern College of Physiotherapy may provide, as a convenience, links to
        websites operated by other entities and persons, but does not endorse or
        accept any responsibility for the content or the use of such websites.
      </Typography>
    </Stack>
  );
};

export default LegalDisclaimer;
